import { useState } from "react";
import { api, callableErrorMessage } from "../lib/api";
import { useAuth } from "../lib/auth";
import { track } from "../lib/analytics";

type Props = {
  tenantId: string;
  amount: number;
  description: string;
  buttonLabel?: string;
  rutPayer?: string;
};

/**
 * Botón que dispara checkout de Mercado Pago.
 * Crea preference vía callable → redirige al init_point.
 */
export function PaymentCheckoutButton({ tenantId, amount, description, buttonLabel, rutPayer }: Props) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const start = async () => {
    setBusy(true);
    setError(null);
    track("payment_checkout_started", { tenant_id: tenantId, amount });
    try {
      const res = await api.createPaymentPreference({
        tenantId,
        amount,
        description,
        currency: "CLP",
        payer: {
          email: user?.email ?? undefined,
          rut: rutPayer
        }
      });
      track("payment_checkout_redirecting", { tenant_id: tenantId, payment_id: res.data.paymentId });
      // Redirigir a MP
      window.location.href = res.data.initPoint;
    } catch (err) {
      track("payment_checkout_failed", { code: (err as { code?: string })?.code ?? "unknown" });
      setError(callableErrorMessage(err));
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <button onClick={start} disabled={busy} className="btn-primary">
        {busy ? "Redirigiendo a Mercado Pago…" : buttonLabel ?? `Pagar $${amount.toLocaleString("es-CL")}`}
      </button>
      {error && (
        <div className="rounded-xl bg-red-50 px-3 py-2 text-xs text-red-700">{error}</div>
      )}
    </div>
  );
}
